import { getApiClient } from "@src/api";
import { graphql } from "@src/gql";

export const registerUser = graphql(/* GraphQL */ `
	mutation RegisterUserMutation(
		$firstName: String!
		$lastName: String!
		$email: String!
		$externalId: String!
		$idProvider: String!
		$avatarUrl: String!
		$referralCode: String
		$demoSessionId: String
		$demoWhiteboardId: String
	) {
		user {
			register(
				firstName: $firstName
				lastName: $lastName
				email: $email
				externalId: $externalId
				idProvider: $idProvider
				avatarUrl: $avatarUrl
				referralCode: $referralCode
				demoSessionId: $demoSessionId
				demoWhiteboardId: $demoWhiteboardId
			) {
				id
				position
				user {
					activationStatus
					avatarUrl
					email
					firstName
					lastName
					phoneActivationCode
					phoneNumber
					externalIdentities {
						id
						provider
					}
				}
			}
		}
	}
`);

export function registerUserMutationFn(user: {
	firstName: string;
	lastName: string;
	email: string;
	externalId: string;
	idProvider: string;
	avatarUrl: string;
	referralCode?: string | null;
	demoSessionId?: string | null;
	demoWhiteboardId?: string | null;
}) {
	const client = getApiClient();
	return client.mutate({
		mutation: registerUser,
		variables: {
			...user,
		},
	});
}
